// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.title-row h2 {
  margin: 0;
}

.create-new-spec-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: #0066b2;
  font-size: 14px;
  font-family: "Gotham", Arial, sans-serif;
  cursor: pointer;
  padding: 4px 8px;
  white-space: nowrap;
}
.create-new-spec-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.create-new-spec-btn:hover {
  color: #0b2d71;
  text-decoration: underline;
}

h2 {
  text-align: left;
}

.search-tips {
  margin: 10px 25px;
  color: #707070;
}

.add-search-results-to-workspace-button {
  background-color: #0066b2;
  color: #ffffff;
  border: none;
  padding: 0 20px;
  margin-right: auto;
  font-size: 14px;
  font-family: "GothamBold", Arial, sans-serif;
}

.add-search-results-to-workspace-button:hover {
  cursor: pointer;
  background-color: #0b2d71;
}

.container-horizontal {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.container-vertical, .filters-container {
  display: flex;
  flex-direction: column;
  flex-grow: 3;
}

.search-result-pane {
  flex: 3 100%;
  flex-basis: 100%;
  max-width: 75%;
}

.filters-container {
  width: 25%;
  max-width: 300px;
  margin-top: 10px;
  overflow-y: auto;
}

.filter-group * {
  justify-content: space-between;
}

.filter-group-item {
  padding-left: 24px;
  line-height: 40px;
  border: 1px solid rgb(237, 237, 238);
  border-radius: 3px;
}
.filter-group-item span {
  color: #0066b2;
  font-size: 12px;
  font-weight: bold;
}

.filter-group-heading {
  align-items: center;
  line-height: 40px;
  border: none;
  border-radius: 3px;
  font-weight: bolder;
  color: black;
  max-height: 40px;
}
.filter-group-heading p {
  margin-left: 10px;
}

.items-per-page {
  margin: 2%;
}

.mat-mdc-paginator-container > * {
  font-family: "Gotham", "Arial", sans-serif;
}

.mat-mdc-select-min-line {
  font-family: "Gotham", "Arial", sans-serif;
}

.reset {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.reset .text-button {
  font-size: 14px;
  margin-bottom: 20px;
  padding-right: 4%;
}
.reset .small-filter-heading {
  font-size: 18px;
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
}

.reset-lower {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.reset-lower .text-button {
  font-size: 14px;
  padding-right: 4%;
}

.type-filter-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.type-filter-container .type-sub-container {
  display: flex;
  align-items: center;
}
.type-filter-container input {
  width: 15px;
  height: 15px;
}
.type-filter-container .checkbox-type-label {
  margin-left: 10px;
  font-size: 16px;
  font-weight: bolder;
}

.include-non-current-container {
  display: flex;
  align-items: center;
  margin: 12px 0 16px;
  padding-left: 6px;
}
.include-non-current-container .mat-mdc-slide-toggle label {
  font-size: 16px;
  font-weight: bolder;
  color: black;
}

.export-buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 25px;
  margin-left: 25px;
}

.progress-bar-container {
  min-height: 6px;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 25px;
  margin-left: 25px;
}
.progress-bar-container .searching-progress-bar {
  height: 5px;
}

.spinner-message {
  display: flex;
  font-style: "Gotham", Arial, sans-serif;
  align-items: center;
}
.spinner-message .mat-mdc-progress-spinner {
  margin-right: 10px;
  margin-left: 10px;
}

.welding-procedure-preview-pane {
  top: 100px;
}

.horizontal-container-for-results-and-preview {
  display: flex;
  align-items: center;
  flex-grow: 3;
}

.filter-selection-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
  padding: 20px 25px;
}
.filter-selection-container .filter-selection-item {
  flex: 0 0 33%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 1%;
}
.filter-selection-container .chips-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.filter-selection-container .chips-container mat-chip-option {
  border-radius: 5px;
  background-color: #0066b2;
}
.filter-selection-container .chips-container mat-chip-option span {
  color: white;
}
.filter-selection-container .chips-container button[matChipRemove] {
  color: white;
}
.filter-selection-container .chips-container button[matChipRemove]:hover {
  opacity: 0.7;
  cursor: pointer;
}

.chips-container * {
  color: white;
}

.temp-unit-container {
  display: inline-flex;
  flex-direction: row;
}

.fahrenheit-container {
  margin-right: 10px;
}

.temp-range-panel {
  border: 1px solid #ededee;
  border-radius: 0;
}
.temp-range-panel .mat-expansion-panel-header-title {
  color: #0066b2;
  font-size: 12px;
  font-weight: 600;
}
.temp-range-panel .temp-unit-container {
  margin-bottom: 8px;
}

.temp-group + .temp-group {
  margin-top: 20px;
}
.temp-group mat-form-field {
  width: 100%;
  margin-bottom: 4px;
}
.temp-group .mat-mdc-form-field-infix {
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: unset;
}

.temp-section-label {
  font-size: 11px;
  font-weight: 700;
  color: #707070;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 6px;
}

.temp-range-input {
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  font-size: 14px;
  font-family: "Gotham", Arial, sans-serif;
  color: #000000;
  box-sizing: border-box;
  background: transparent;
}
.temp-range-input:focus {
  outline: none;
  border-color: #0066b2;
  border-width: 2px;
  padding: 0 11px;
}
.temp-range-input::placeholder {
  color: rgba(0, 0, 0, 0.42);
}

.temp-input-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.temp-input-row .temp-range-input {
  flex: 1;
  min-width: 0;
  width: auto;
}

.temp-apply-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.temp-apply-btn {
  flex-shrink: 0;
  height: 42px;
  padding: 0 10px;
  background: none;
  border: 1px solid #0066b2;
  border-radius: 4px;
  color: #0066b2;
  font-size: 12px;
  font-family: "Gotham", Arial, sans-serif;
  cursor: pointer;
  white-space: nowrap;
}
.temp-apply-btn:hover {
  background: rgba(0, 102, 178, 0.06);
}
.temp-apply-btn:active {
  background: rgba(0, 102, 178, 0.14);
}

.piping-panel {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1607843137);
  opacity: 1;
  margin: 32px 25px;
  padding: 12px 0;
}
.piping-panel .piping-title {
  display: flex;
  justify-content: space-between;
  margin-left: 2%;
  width: 95%;
  font-family: "GothamBold", Arial, sans-serif;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 0px;
  color: #0066b2;
}
.piping-panel .piping-subtitle {
  display: flex;
  width: 95%;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
  color: #0066b2;
  margin-left: 2%;
  margin-right: 2%;
}
.piping-panel .prop-label {
  font-family: "Gotham", Arial, sans-serif;
  font-weight: 100;
  font-size: 14px;
  text-align: left;
  letter-spacing: 0px;
  color: #8c8f93;
  opacity: 1;
  margin: 0;
  padding: 0;
}
.piping-panel .prop-value {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
  font-weight: 100;
  text-align: left;
  color: #000000;
  margin: 0;
  padding: 0;
}

.modal-type-info {
  padding: 8px 16px;
  background-color: rgba(0, 123, 255, 0.05);
  border-left: 4px solid #007bff;
  margin-bottom: 16px;
  border-radius: 4px;
}
.modal-type-info .type-info-display {
  display: flex;
  align-items: center;
  gap: 8px;
}
.modal-type-info .type-info-display .filter-type-label {
  font-weight: 500;
  color: #555;
}
.modal-type-info .type-info-display .filter-type-value {
  font-weight: 600;
  color: #007bff;
}

.modal-table-container {
  width: 100%;
  overflow-x: auto;
  max-height: 60vh;
  overflow-y: auto;
}
.modal-table-container .modal-results-table {
  width: 100%;
}
.modal-table-container .modal-results-table .mat-mdc-header-cell {
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #007bff;
}
.modal-table-container .modal-results-table .mat-mdc-cell {
  border-bottom: 1px solid #e0e0e0;
}
.modal-table-container .modal-results-table .mat-mdc-cell.disabled-item {
  color: #999;
  font-style: italic;
}
.modal-table-container .modal-results-table .mat-mdc-row {
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.modal-table-container .modal-results-table .mat-mdc-row:hover {
  background-color: rgba(0, 123, 255, 0.05);
}
.modal-table-container .modal-results-table .mat-mdc-row.selected-row {
  background-color: rgba(0, 123, 255, 0.1);
  border-left: 4px solid #007bff;
}
.modal-table-container .modal-results-table .mat-mdc-row.disabled-row {
  background-color: rgba(128, 128, 128, 0.05);
  cursor: not-allowed;
}
.modal-table-container .modal-results-table .mat-mdc-row.disabled-row:hover {
  background-color: rgba(128, 128, 128, 0.05);
}
.modal-table-container .modal-results-table .disabled-item {
  opacity: 0.6;
  color: #999;
}
.modal-table-container .modal-results-table .mat-column-select {
  width: 48px;
  max-width: 48px;
  min-width: 48px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-table-container .modal-results-table .modal-select-cell .mat-mdc-checkbox {
  margin: 0;
}
.modal-table-container .modal-results-table .mat-column-tag {
  width: 120px;
}
.modal-table-container .modal-results-table .mat-column-type {
  width: 100px;
}
.modal-table-container .modal-results-table .mat-column-size {
  width: 80px;
}
.modal-table-container .modal-results-table .mat-column-rating {
  width: 100px;
}
.modal-table-container .modal-results-table .mat-column-material {
  width: 120px;
}
.modal-table-container .modal-results-table .mat-column-description {
  flex: 1;
  min-width: 200px;
}

.valve-selection-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px;
  border: 2px solid transparent;
  border-radius: 4px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
}
.valve-selection-item:hover {
  background-color: rgba(0, 123, 255, 0.05);
  border-color: rgba(0, 123, 255, 0.2);
}
.valve-selection-item.selected {
  background-color: rgba(0, 123, 255, 0.1);
  border-color: #007bff;
}
.valve-selection-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: rgba(128, 128, 128, 0.1);
}
.valve-selection-item.disabled:hover {
  background-color: rgba(128, 128, 128, 0.1);
  border-color: transparent;
}
.valve-selection-item .valve-checkbox {
  flex-shrink: 0;
  margin-top: 4px;
}
.valve-selection-item .valve-content {
  flex: 1;
}
.valve-selection-item .valve-content:hover {
  cursor: pointer;
}
.valve-selection-item.disabled .valve-content {
  pointer-events: none;
}

.tag-text {
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
